export default __webpack_public_path__ + "img/nyt.226a5508.svg";